// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__21GwE","label":"Completed_label__3RCGg"};